/* mm-ruhe.js — nichts läuft, wenn niemand hinsieht. Und wenn, dann ruhiger.
 *
 * 29.08.2026, Mert: „Langsamer und erst, wenn das Auge draufschaut. Wenn das Auge
 * nicht draufschaut, nicht animieren. Aber das gilt nicht nur hier, das gilt
 * überall. Das ist auch gut für die Optimierung."
 *
 * Bisher hat jede Sektion das für sich geregelt - und jede neue musste wieder
 * daran denken. Diese Datei zieht die Regel EINMAL über die ganze Seite, auch
 * über Sektionen von Apps und dem Theme, an die ich sonst nicht herankomme.
 *
 * WAS SIE TUT
 *   1. Sie sucht alle Elemente mit einer ENDLOS laufenden Animation.
 *   2. Jedes davon bekommt einen Beobachter: aus dem Bild -> `paused`,
 *      wieder im Bild -> weiter, und zwar an derselben Stelle.
 *   3. Ist der Tab weg (`document.hidden`), steht alles still.
 *   4. Was schneller als 1,4 s durchläuft, wird auf das 1,7-fache gedehnt -
 *      höchstens auf 2,4 s. Genau die zappeligen Sachen werden also ruhiger,
 *      die langsamen bleiben, wie sie gedacht waren.
 *
 * WARUM `animation-play-state` UND NICHT `display:none`
 *   Pausieren hält den Stand fest: wer zurückscrollt, sieht dort weiter, wo er
 *   war - kein Sprung (feste Regel 23.08.2026, Punkt 5).
 *
 * WAS SIE BEWUSST NICHT ANFASST
 *   - `#mmSE` (Story-Leiste) und alles mit `data-mm-ruhe="aus"`: die regeln sich
 *     selbst, zweimal steuern hieße gegeneinander steuern.
 *   - Übergänge (`transition`). Die laufen ohnehin nur auf Zuruf.
 *   - Animationen, die nur einmal laufen. Die sind nach einer Sekunde vorbei.
 *
 * KOSTEN
 *   `getComputedStyle` über alle Elemente ist teuer, deshalb genau EIN
 *   vollständiger Durchgang. Danach werden nur noch neu hinzugekommene Knoten
 *   angesehen, und auch das gedrosselt - Apps bauen sekundenlang nach.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var SCHNELL = 1.4;     /* alles darunter gilt als zappelig */
  var FAKTOR = 1.7;
  var HOECHST = 2.4;
  var bekannt = new WeakSet();

  var auge = new IntersectionObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      e.target.style.animationPlayState =
        (e.isIntersecting && !document.hidden) ? '' : 'paused';
    }
  }, { rootMargin: '140px' });

  function ausgenommen(el) {
    if (el.dataset && el.dataset.mmRuhe === 'aus') return true;
    if (el.closest && el.closest('#mmSE, [data-mm-ruhe="aus"]')) return true;
    return false;
  }

  function sekunden(wert) {
    /* animation-duration kann mehrere Werte haben - der laengste zaehlt. */
    var teile = String(wert || '').split(',');
    var max = 0;
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i].trim();
      var n = parseFloat(t);
      if (isNaN(n)) continue;
      if (t.indexOf('ms') > -1) n = n / 1000;
      if (n > max) max = n;
    }
    return max;
  }

  function pruefen(el) {
    if (bekannt.has(el)) return;
    var s;
    try { s = window.getComputedStyle(el); } catch (x) { return; }
    if (!s || s.animationName === 'none' || !s.animationName) return;
    if (String(s.animationIterationCount).indexOf('infinite') === -1) return;
    bekannt.add(el);
    if (ausgenommen(el)) return;

    var d = sekunden(s.animationDuration);
    if (d > 0 && d < SCHNELL && !el.dataset.mmDauer) {
      el.dataset.mmDauer = String(d);
      el.style.animationDuration = Math.min(HOECHST, d * FAKTOR).toFixed(2) + 's';
    }
    auge.observe(el);
  }

  function durchgang(wurzel) {
    var alle = (wurzel || document).querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) pruefen(alle[i]);
  }

  function start() {
    durchgang(document);

    if (window.MutationObserver) {
      var wartet = false, offen = [];
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) {
          for (var j = 0; j < m[i].addedNodes.length; j++) {
            var k = m[i].addedNodes[j];
            if (k.nodeType === 1) offen.push(k);
          }
        }
        if (wartet || !offen.length) return;
        wartet = true;
        window.setTimeout(function () {
          wartet = false;
          var liste = offen; offen = [];
          for (var n = 0; n < liste.length; n++) {
            pruefen(liste[n]);
            durchgang(liste[n]);
          }
        }, 900);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('visibilitychange', function () {
      /* Beim Zurueckkommen entscheidet der Beobachter neu - deshalb hier nur
         anhalten, nicht wieder anwerfen. */
      if (!document.hidden) return;
      var alle = document.querySelectorAll('[style*="animation-play-state"], *');
      for (var i = 0; i < alle.length; i++) {
        if (bekannt.has(alle[i])) alle[i].style.animationPlayState = 'paused';
      }
    });
  }

  /* Erst nach dem Laden - vorher steht ohnehin noch nicht viel im Dokument. */
  if (document.readyState === 'complete') window.setTimeout(start, 400);
  else window.addEventListener('load', function () { window.setTimeout(start, 400); });
})();
